<template>
    <div class="seminar-form-wrapper">
      <div class="form-container">
        <div class="form-intro text-center">
            <h4>Organisez votre événement sur-mesure dès maintenant !</h4>
            <p>Remplissez ce formulaire et notre équipe vous recontactera avec une proposition personnalisée.</p>
        </div>
				<div v-if="step !== 4" class="form-steps">
					<div :class="['step-circle', step === 1 ? 'active' : '']">1</div>
					<div class="step-line"></div>
					<div :class="['step-circle', step === 2 ? 'active' : '']">2</div>
					<div class="step-line"></div>
					<div :class="['step-circle', step === 3 ? 'active' : '']">3</div>
				</div>
				<div v-if="step !== 4" class="form-steps-labels">
					<div class="form-steps-labels">
							<span>Informations & contact</span>
							<span>Détails de l'événement</span>
							<span>Finalisation & envoi</span>
					</div>
				</div>
        <div class="form-box" :class="{ 'no-style': step === 4 }">
            <div class="multi-step-form " :class="{ 'no-max-width': step === 4 }">
                <div v-if="step === 1">
                <StepOne v-model="form" @next="handleStepOneComplete" />
                </div>
                <div v-else-if="step === 2">
                <StepTwo v-model="form" @prev="step--" @next="step++" />
                </div>
                <div v-else-if="step === 3">
                <StepThree v-model="form" @prev="step--" @submit="submitForm" />
                </div>
                <div v-else-if="step === 4">
                <Confirmation />
                </div>
            </div>
        </div>
      </div>  
    </div>
  </template>
  
  
  <script>
  import StepOne from './StepOne.vue'
  import StepTwo from './StepTwo.vue'
  import StepThree from './StepThree.vue'
  import Confirmation from './Confirmation.vue'
  import SeminarDifference from '../../components/SeminarDifference.vue';
	import ArrowLeft from '../../images/Groupe 180.svg';
	import ArrowLeftMobile from '../../images/Groupe 178.svg';
  import fetcher from 'packs/shared/api.js';

  export default {
    name: "MultiStepForm",
    components: { StepOne, StepTwo, StepThree, Confirmation, SeminarDifference },
    data() {
		return {
				ArrowLeft,
				ArrowLeftMobile,
				step: 1,
				form: {
				firstName: '',
				lastName: '',
				company: '',
				position: '',
				email: '',
				phone: '',
				arrival: '',
				departure: '',
				flexible: false,
				participants: '',
				location: '',
				eventTypes: [],
				specificNeeds: [],
				otherEventType: '',
				otherNeeds: '',
				contactPreference: '',
				phoneSlot: ''
				},
				icons: [
				{
					image: require('../../images/Groupe 151.svg'),
						alt: "Maison",
						label: "UNE SÉLECTION UNIQUE DE LIEUX DE CHARME"
				},
				{
						image: require('../../images/Groupe 1622.svg'),
						alt: "Checklist",
						label: "UNE ORGANISATION CLÉ EN MAIN"
				},
				{
						image: require('../../images/Groupe 175.svg'),
						alt: "Bien-être",
						label: "DES HÉBERGEMENTS RESPECTUEUX DE L’ENVIRONNEMENT"
				},
				{
						image: require('../../images/Groupe 163.svg'),
						alt: "Feuille",
						label: "UNE EXPÉRIENCE 100% ÉCO-RESPONSABLE"
				},
				{
						image: require('../../images/Groupe 158.svg'),
						alt: "Cadeau",
						label: "UN MOMENT PRIVILÉGIÉ À OFFRIR À VOS ÉQUIPES"
				}
				]
		}
		},

    methods: {
			goBack() {
				window.location.href = '/seminaire-eco-responsable';
			},
			async submitForm() {
			},
      async submitForm() {
        const formData = new FormData()
        Object.entries(this.form).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            formData.append(key, value.join(', '))
          } else {
            formData.append(key, value)
          }
        })
        try {
          await fetch('https://formspree.io/f/mpwrdeag', {
            method: 'POST',
            body: formData,
            headers: {
              Accept: 'application/json'
            }
          })
          this.step++
        } catch (error) {
          alert('Une erreur est survenue. Veuillez réessayer.')
        }
      }
    },
    async handleStepOneComplete() {
      try {
        const response = await fetcher.post('/users/create_partial_seminar_user', {
            user: {
              first_name: this.form.firstName,
              last_name: this.form.lastName,
              // company: this.form.company,
              // position: this.form.position,
              email: this.form.email,
              phone: this.form.phone
            }
        });
        const result = await response.json();
        if (result.success) {
          this.step++;
        } else {
          this.step++;
          // alert('Une erreur est survenue. Veuillez vérifier les informations ou réessayer.');
        }
      } catch (error) {
        console.error(error);
        this.step++;
        // alert("Erreur lors de l'enregistrement. Veuillez réessayer.");
      }
    }
  }
  </script>
  
<style scoped>

.multi-step-form {
max-width: 700px;
margin: 0 auto;
}
.multi-step-form.no-max-width {
  max-width: none;
}
.seminar-form-wrapper {
  font-family: 'Raleway', sans-serif;
}

.seminar-form-wrapper h1,
.seminar-form-wrapper h2,
.seminar-form-wrapper h3,
.seminar-form-wrapper h4 {
  font-family: 'Merriweather', serif;
}
.raleway-reg-p15 {
  font-family: 'Raleway', sans-serif;
  font-size: 15px;
  font-weight: 400;
}
.form-container{
    max-width: 900px;
    margin: 0 auto;
    @media(max-width: 786px){
        margin: 1rem;
    }
}

.hero-banner {
  position: relative;
  height: 350px;
  overflow: hidden;
}

.hero-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-title {
  position: absolute;
  bottom: 150px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
	font-size: 2.8rem;
}

.form-intro {
  margin-top: 2rem;
  text-align: center;
}

.form-steps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0 1rem;
	margin-left: 1rem;
	margin-right: 1rem;
}

.step-circle {
  width: 32px;
  height: 32px;
  border: 2px solid #345b48;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #345b48;
  background-color: white;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.step-circle.active {
  background-color: #345b48;
  color: white;
}

.step-line {
  width: 2000px;
  height: 2px;
  background-color: #345b48;
  margin: 0 0px;
}

.form-steps-labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2rem;
  font-size: 0.9rem;
  color: #333;
}
.form-box {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0px 0 24px -4px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  margin: 0 auto 3rem;
  max-width: 700px;
}
.form-box.no-style {
  background-color: transparent;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  margin: 0;
  max-width: none;
}


.retour-desktop {
  display: block;
}

.retour-mobile {
  display: none;
}

@media screen and (max-width: 768px) {
  .retour-desktop {
    display: none;
  }
  .retour-mobile {
    display: block;
  }
}

.back-button {
  position: absolute;
	padding: 0px;
	position: absolute;
	top: 13rem;
  z-index: 10;
	background: none;
	@media(max-width: 480px){
		top: 4rem;
	}
}

.back-button img.retour-mobile {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 10px;
}
</style>
  